import { EquipmentType } from './damage';

/*
 * Size types are now a backend-managed catalog served via `GET /size-types`.
 * The value stored on a record (`unit.size_type`, `redelivery_detail.size_type`,
 * `booking_detail_iso.iso`) is the option's `code` string — identical to the
 * previously hardcoded values — so `SizeType` stays a string alias to preserve
 * every existing annotation and `as X` cast with zero churn.
 * Selection-time options come from the SizeTypeProvider (`useSizeTypes`), not this module.
 */
export type SizeType = string;

/* active option for dropdowns — carries equipmentType for selection-time derivation */
export interface SizeTypeOption {
  code: string;
  label: string;
  equipmentType: EquipmentType;
  /* false only for retired rows, which `/options?includeInactive=true` returns for display. Absent = active. */
  active?: boolean;
  /* moves of this size type record reefer details; the catalog decides, never the code's spelling */
  reefer?: boolean;
}

/* admin CRUD row shape (incl. inactive) for the `/size-types` lookup endpoints */
export interface SizeTypeLookupOption extends SizeTypeOption {
  id: number;
  active: boolean;
}

/*
 * Combo size types are a frontend-only presentation overlay (Option A): the backend
 * catalog stores only the atomic codes (`40HC`, `40ST`, `40HH`, `40SH`). These combos
 * are injected exclusively into the booking accept-list dropdown so a single booking
 * line can accept either underlying code. Shaped as [label, [code, code]] to match the
 * catalog entries consumed by the booking size-type selectors.
 */
export const SIZE_TYPE_COMBOS: [string, string[]][] = [
  ['40HC/ST', ['40HC', '40ST']],
  ['40HH/SH', ['40HH', '40SH']]
];
